import {RouteEquipmentTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class RouteEquipmentTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in RouteEquipmentTypeCd ) {
      this._values.push(RouteEquipmentTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): RouteEquipmentTypeCd {

    for ( const obj in RouteEquipmentTypeCd ) {
      if (RouteEquipmentTypeCd[obj] === value){
        return RouteEquipmentTypeCd[obj] as RouteEquipmentTypeCd;
      }
    }
  }
}

const RouteEquipmentTypeCdHelper = new RouteEquipmentTypeCdHelperEnumHelperClass();
export default RouteEquipmentTypeCdHelper;
